var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-students-wrapper",
    },
    [
      _vm.tasks.length > 0
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("thead", [
                _c(
                  "tr",
                  {
                    staticClass: "sortable",
                  },
                  [
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("Status")))]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("task-title"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("task-title")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Aufgabentitel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("solver-name"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("solver-name")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Teilnehmende/Gruppen")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden",
                        class: _vm.getSortClass("page-title"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("page-title")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Seite")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("progress"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("progress")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("bearbeitet")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("submission-date"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("submission-date")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Abgabefrist")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("Abgabe")))]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden renewal",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Verlängerungsanfrage")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden feedback",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Feedback")))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.tasks, function (_ref) {
                  var _task$attributes, _task$attributes$prog

                  var task = _ref.task,
                    taskGroup = _ref.taskGroup,
                    status = _ref.status,
                    element = _ref.element,
                    user = _ref.user,
                    group = _ref.group,
                    feedback = _ref.feedback
                  return _c(
                    "tr",
                    {
                      key: task.id,
                    },
                    [
                      _c(
                        "td",
                        [
                          status.shape !== undefined
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: status.shape,
                                  role: status.role,
                                  title: status.description,
                                  "aria-hidden": "true",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "sr-only",
                            },
                            [_vm._v(_vm._s(status.description))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(taskGroup && taskGroup.attributes.title) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        user
                          ? _c(
                              "span",
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "person2",
                                    role: "info",
                                    "aria-hidden": "true",
                                    title: _vm.$gettext("Teilnehmende Person"),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "sr-only",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$gettext("Teilnehmende Person")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(user.attributes["formatted-name"]) +
                                    "\n\n                    "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        group
                          ? _c(
                              "span",
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "group2",
                                    role: "info",
                                    "aria-hidden": "true",
                                    title: _vm.$gettext("Gruppe"),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "sr-only",
                                  },
                                  [_vm._v(_vm._s(_vm.$gettext("Gruppe")))]
                                ),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(group.attributes["name"]) +
                                    "\n\n                    "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          task.attributes.submitted
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.getLinkToElement(element),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(element.attributes.title) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(element.attributes.title)),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            ((_task$attributes = task.attributes) === null ||
                            _task$attributes === void 0
                              ? void 0
                              : (_task$attributes$prog =
                                  _task$attributes.progress) === null ||
                                _task$attributes$prog === void 0
                              ? void 0
                              : _task$attributes$prog.toFixed(2)) || "-.--"
                          ) + "%"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.getReadableDate(
                              task.attributes["submission-date"]
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          task.attributes.submitted
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: "accept",
                                  role: "status-green",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "pending",
                                  expression:
                                    "task.attributes.renewal === 'pending'",
                                },
                              ],
                              staticClass: "button",
                              on: {
                                click: function click($event) {
                                  return _vm.solveRenewalRequest(task)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("Anfrage bearbeiten")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "declined",
                                  expression:
                                    "task.attributes.renewal === 'declined'",
                                },
                              ],
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "decline",
                                  role: "status-red",
                                },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("Anfrage abgelehnt")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: task.attributes.renewal === "granted",
                                  expression:
                                    "task.attributes.renewal === 'granted'",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("verlängert bis")) +
                                  ":\n                        " +
                                  _vm._s(
                                    _vm.getReadableDate(
                                      task.attributes["renewal-date"]
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          task.attributes.renewal === "declined" ||
                          task.attributes.renewal === "granted"
                            ? _c("studip-icon", {
                                staticClass: "edit",
                                attrs: {
                                  title: _vm.$gettext("Anfrage bearbeiten"),
                                  shape: "edit",
                                  role: "clickable",
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.solveRenewalRequest(task)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "responsive-hidden",
                        },
                        [
                          feedback
                            ? _c(
                                "span",
                                {
                                  attrs: {
                                    title:
                                      _vm.$gettext("Feedback geschrieben am:") +
                                      " " +
                                      _vm.getReadableDate(
                                        feedback.attributes["chdate"]
                                      ),
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "accept",
                                      role: "status-green",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$gettext("Feedback gegeben")) +
                                      "\n                        "
                                  ),
                                  _c("studip-icon", {
                                    staticClass: "edit",
                                    attrs: {
                                      title: _vm.$gettext(
                                        "Feedback bearbeiten"
                                      ),
                                      shape: "edit",
                                      role: "clickable",
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.editFeedback(feedback)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !feedback && task.attributes.submitted,
                                  expression:
                                    "!feedback && task.attributes.submitted",
                                },
                              ],
                              staticClass: "button",
                              on: {
                                click: function click($event) {
                                  return _vm.addFeedback(task)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("Feedback geben")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _c(
            "div",
            [
              _c("courseware-companion-box", {
                attrs: {
                  mood: "pointing",
                  msgCompanion: _vm.$gettext(
                    "Es wurden bisher keine Aufgaben gestellt."
                  ),
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.showRenewalDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.text.renewalDialog.title,
              confirmText: _vm.text.renewalDialog.confirm,
              confirmClass: "accept",
              closeText: _vm.text.renewalDialog.close,
              closeClass: "cancel",
              height: "350",
            },
            on: {
              close: function close($event) {
                _vm.showRenewalDialog = false
                _vm.currentDialogTask = {}
              },
              confirm: _vm.updateRenewal,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Fristverlängerung")) +
                                "\n                    "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.currentDialogTask.attributes.renewal,
                                    expression:
                                      "currentDialogTask.attributes.renewal",
                                  },
                                ],
                                on: {
                                  change: function change($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })

                                    _vm.$set(
                                      _vm.currentDialogTask.attributes,
                                      "renewal",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "declined",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("ablehnen")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  {
                                    attrs: {
                                      value: "granted",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("gewähren")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.currentDialogTask.attributes.renewal === "granted"
                            ? _c(
                                "label",
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$gettext("neue Frist")) +
                                      "\n                    "
                                  ),
                                  _c("courseware-date-input", {
                                    staticClass: "size-l",
                                    model: {
                                      value:
                                        _vm.currentDialogTask.attributes[
                                          "renewal-date"
                                        ],
                                      callback: function callback($$v) {
                                        _vm.$set(
                                          _vm.currentDialogTask.attributes,
                                          "renewal-date",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "currentDialogTask.attributes['renewal-date']",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2430434261
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditFeedbackDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.text.editFeedbackDialog.title,
              confirmText: _vm.text.editFeedbackDialog.confirm,
              confirmClass: "accept",
              closeText: _vm.text.editFeedbackDialog.close,
              closeClass: "cancel",
              height: "420",
            },
            on: {
              close: function close($event) {
                _vm.showEditFeedbackDialog = false
                _vm.currentDialogFeedback = {}
              },
              confirm: _vm.updateFeedback,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _vm.currentDialogFeedback.attributes.content === ""
                        ? _c("courseware-companion-box", {
                            attrs: {
                              mood: "pointing",
                              msgCompanion: _vm.$gettext(
                                "Sie haben kein Feedback geschrieben, beim Speichern wird dieses Feedback gelöscht!"
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Feedback")) +
                                "\n                    "
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.currentDialogFeedback.attributes
                                      .content,
                                  expression:
                                    "currentDialogFeedback.attributes.content",
                                },
                              ],
                              domProps: {
                                value:
                                  _vm.currentDialogFeedback.attributes.content,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) {
                                    return
                                  }

                                  _vm.$set(
                                    _vm.currentDialogFeedback.attributes,
                                    "content",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3358344397
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddFeedbackDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.text.addFeedbackDialog.title,
              confirmText: _vm.text.addFeedbackDialog.confirm,
              confirmClass: "accept",
              closeText: _vm.text.addFeedbackDialog.close,
              closeClass: "cancel",
            },
            on: {
              close: function close($event) {
                _vm.showAddFeedbackDialog = false
                _vm.currentDialogFeedback = {}
              },
              confirm: _vm.createFeedback,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Feedback")) +
                                "\n                    "
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.currentDialogFeedback.attributes
                                      .content,
                                  expression:
                                    "currentDialogFeedback.attributes.content",
                                },
                              ],
                              domProps: {
                                value:
                                  _vm.currentDialogFeedback.attributes.content,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) {
                                    return
                                  }

                                  _vm.$set(
                                    _vm.currentDialogFeedback.attributes,
                                    "content",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              971910636
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTasksDistributeDialog
        ? _c("courseware-tasks-dialog-distribute", {
            on: {
              newtask: _vm.reloadTasks,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [_c("col")])
  },
]
render._withStripped = true

export { render, staticRenderFns }